import React from 'react';
import { ITextFieldProps, TextField } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { useDetailsFormContext } from '../hooks/useDetailsFormContext';

export const Address = (props: Partial<ITextFieldProps>) => {
	const { t } = useTranslation();

	const {
		register,
		formState: { errors },
	} = useDetailsFormContext();

	return (
		<TextField
			label={t('parking_details_form_address_label')}
			placeholder={t('parking_details_form_address_placeholder')}
			invalid={!!errors.address}
			error={errors.address?.message}
			autoComplete="street-address"
			{...props}
			{...register('address')}
		/>
	);
};
